import { logDebugCacheEvent, logImpressionEvent, } from '@office-start/instrumentation-service';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { getIsPageVisible } from '@office-start/page-visibility-service';
import { mark } from '@office-start/performance-service';
import { IDLE_VERYLOW_PRIORITY, scheduleWork, } from '@office-start/scheduler-service';
import { logError, logFeature, logImpression, } from '@office-start/telemetry-service';
import { useCallback, useMemo, useRef } from 'react';
export var useVisualBackgroundTelemetry = function (options) {
    var isPaintMarkerRecorded = useRef(false);
    var currentThemeMode = useRef('');
    var area = 'Visuals';
    var subArea = 'VisualBackground';
    var featureName = "Visuals" /* KnownFeatureNames.Visuals */;
    var backgroundImageLoadEventName = 'VisualBackgroundImageLoad';
    var themeMode = options.themeMode, themeId = options.themeId;
    // Log impression event
    var logVisualBackgroundImpression = useCallback(function (latency, isCached) {
        if (!themeMode ||
            !themeId ||
            (isPaintMarkerRecorded.current &&
                currentThemeMode.current === themeMode)) {
            return;
        }
        scheduleWork(function () {
            logImpression({
                area: area,
                subArea: subArea,
                eventName: "VisualBackground_Impression" /* KnownImpressionInstrumentationEvents.VisualBackgroundImpression */,
            });
            // Log to Aria
            var params = {};
            params["Area" /* InstrumentationParam.Area */] = 'VisualBackground';
            logImpressionEvent("VisualBackground_Impression" /* KnownImpressionInstrumentationEvents.VisualBackgroundImpression */, params);
            logFeature({
                area: area,
                subArea: subArea,
                eventName: backgroundImageLoadEventName,
                featureName: featureName,
                params: {
                    State: 'Success',
                    Latency: Math.ceil(latency).toString(),
                    ThemeId: themeId,
                    ThemeMode: themeMode,
                    Cached: isCached ? 'True' : 'False',
                    ScreenWidth: screen.width,
                    ScreenHeight: screen.height,
                },
            });
        }, IDLE_VERYLOW_PRIORITY);
        if (getIsPageVisible()) {
            mark("".concat(area, "_Paint"));
        }
        isPaintMarkerRecorded.current = true;
        currentThemeMode.current = themeMode;
    }, [themeMode, themeId, featureName]);
    // Log impression event
    var logVisualBackgroundError = useCallback(function (latency, errorEvent) {
        var _a;
        logError({
            area: area,
            eventName: 'VisualBackgroundImageError',
            subArea: subArea,
        });
        // Log to Aria
        var message = '';
        if ((errorEvent === null || errorEvent === void 0 ? void 0 : errorEvent.currentTarget) instanceof HTMLImageElement) {
            message = "Unable to load image: ".concat(errorEvent.currentTarget.currentSrc);
        }
        logDebugCacheEvent(KnownInstrumentationEvents.VisualBackgroundImageError, (_a = {}, _a["DebugInfo" /* InstrumentationParam.DebugInfo */] = message, _a));
        logFeature({
            area: area,
            subArea: subArea,
            eventName: backgroundImageLoadEventName,
            featureName: featureName,
            params: {
                State: 'Error',
                Latency: latency.toString(),
                ThemeId: themeId !== null && themeId !== void 0 ? themeId : '',
                ThemeMode: themeMode !== null && themeMode !== void 0 ? themeMode : '',
            },
        });
    }, [featureName, themeId, themeMode]);
    return useMemo(function () {
        return {
            logVisualBackgroundImpression: logVisualBackgroundImpression,
            logVisualBackgroundError: logVisualBackgroundError,
        };
    }, [logVisualBackgroundImpression, logVisualBackgroundError]);
};
//# sourceMappingURL=useVisualBackgroundTelemetry.js.map